import { Card } from "./card";

interface PlatesHeatExchangerProps {
  efficiency?: number;
}

const PlatesHeatExchanger: React.FC<PlatesHeatExchangerProps> = ({ efficiency }) => {
  const formattedEfficiency = efficiency?.toFixed(1) ?? "--";

  return (
    <div className="before:h-23.5 gap-1.25 after:h-23.5 relative my-auto flex w-fit flex-col items-center [grid-area:platesHeatExchanger] before:absolute before:top-px before:z-[-1] before:w-full before:border-t before:border-b before:border-primary-dark-gray before:bg-neutral-100 before:content-[''] after:absolute after:bottom-px after:z-[-1] after:w-full after:border-t after:border-b after:border-primary-dark-gray after:bg-neutral-100 after:content-['']">
      <Card className="-top-2.5 absolute -translate-y-full">{`${formattedEfficiency} %`}</Card>
      <svg width="228" height="230" viewBox="0 0 228 230" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="113" y="1" width="2" height="228" fill="#122138" />
        <mask id="path-3-inside-1_25409_70182" fill="white">
          <path d="M18.541 115L114 19.5406L209.46 115L114 210.459L18.541 115Z" />
        </mask>
        <path d="M18.541 115L114 19.5406L209.46 115L114 210.459L18.541 115Z" fill="#F3F3F9" />
        <path
          d="M18.541 115L17.1268 113.586L15.7126 115L17.1268 116.414L18.541 115ZM114 19.5406L115.415 18.1264L114 16.7122L112.586 18.1264L114 19.5406ZM209.46 115L210.874 116.414L212.288 115L210.874 113.586L209.46 115ZM114 210.459L112.586 211.874L114 213.288L115.415 211.874L114 210.459ZM18.541 115L19.9552 116.414L115.415 20.9548L114 19.5406L112.586 18.1264L17.1268 113.586L18.541 115ZM114 19.5406L112.586 20.9548L208.046 116.414L209.46 115L210.874 113.586L115.415 18.1264L114 19.5406ZM209.46 115L208.046 113.586L112.586 209.045L114 210.459L115.415 211.874L210.874 116.414L209.46 115ZM114 210.459L115.415 209.045L19.9552 113.586L18.541 115L17.1268 116.414L112.586 211.874L114 210.459Z"
          fill="#122138"
          mask="url(#path-3-inside-1_25409_70182)"
        />
        <path
          d="M109.759 127.73C110.149 128.121 110.149 128.754 109.759 129.145L71.2012 167.702L71.1406 167.762L71.0801 167.819C60.8835 177.536 54.4571 183.829 46.4795 186.98C38.7205 190.046 29.8311 190.004 16.0038 190C15.4516 190 15.001 190.448 15.001 191V196.875C15.001 197.788 13.8773 198.223 13.262 197.548L0.615139 183.676C0.267148 183.294 0.267147 182.71 0.615138 182.328L13.262 168.455C13.8773 167.78 15.001 168.216 15.001 169.129V175C15.001 175.552 15.4546 176 16.0069 176C30.8523 175.994 36.5737 175.84 41.335 173.959C46.1583 172.053 50.3492 168.235 61.3447 157.758L99.8583 119.244C100.249 118.854 100.882 118.854 101.273 119.244L109.759 127.73ZM228.001 53C228.001 53.5523 227.553 54 227.001 54.0001C216.195 54.0009 208.249 54.0118 201.985 54.3096C195.539 54.6161 191.332 55.2137 188.016 56.2275C181.646 58.1749 177.564 61.8538 166.66 72.2432L128.144 110.76C127.753 111.15 127.12 111.15 126.729 110.76L118.243 102.274C117.853 101.883 117.853 101.25 118.243 100.859L156.801 62.3018L156.861 62.2422L160.618 58.667C168.9 50.8266 175.019 45.561 183.924 42.8389C188.888 41.3214 194.448 40.652 201.321 40.3252C207.98 40.0086 216.303 40.0007 227.001 40C227.553 40 228.001 40.4477 228.001 41V53Z"
          fill="url(#paint0_linear_25409_70182)"
        />
        <path
          d="M0.000976562 41C0.000976562 40.4477 0.448998 40 1.0013 40C11.6995 40.0007 20.0216 40.0086 26.6807 40.3252C33.5538 40.652 39.1136 41.3213 44.0781 42.8389C52.9829 45.561 59.1022 50.8266 67.3838 58.667L71.1406 62.2422L71.2012 62.3018L166.657 157.758C177.653 168.235 181.844 172.053 186.667 173.959C191.428 175.84 197.149 175.994 211.995 176C212.547 176 213.001 175.552 213.001 175V169.129C213.001 168.216 214.125 167.78 214.74 168.455L227.387 182.328C227.735 182.71 227.735 183.294 227.387 183.676L214.74 197.548C214.125 198.223 213.001 197.788 213.001 196.875V191C213.001 190.448 212.55 190 211.998 190C198.171 190.004 189.282 190.046 181.522 186.98C173.545 183.829 167.119 177.536 156.922 167.819L156.861 167.762L156.801 167.702L61.3418 72.2432C50.4383 61.8538 46.3562 58.1749 39.9863 56.2275C36.6698 55.2137 32.4634 54.6161 26.0166 54.3096C19.7533 54.0118 11.8069 54.0009 1.00135 54.0001C0.449085 54 0.000976562 53.5523 0.000976562 53V41Z"
          fill="url(#paint1_linear_25409_70182)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_25409_70182"
            x1="228.001"
            y1="47"
            x2="0.00098365"
            y2="183"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.05" stop-color="white" stop-opacity="0" />
            <stop offset="0.25" stop-color="#D0D0D0" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_25409_70182"
            x1="0.00195793"
            y1="46.5"
            x2="228.002"
            y2="182"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.05" stop-color="white" stop-opacity="0" />
            <stop offset="0.254808" stop-color="#D0D0D0" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

PlatesHeatExchanger.displayName = "PlatesHeatExchanger";

export { PlatesHeatExchanger };
export type { PlatesHeatExchangerProps };
